import { mapString, getParam } from "./common";
const productionEnvironment = "prod";
const latestEnvironment = "latest";
const stageEnvironment = "stage";
const loadEnvironment = "lt01";
const latestPrefixEnvironment = `${latestEnvironment}.`;
const stagePrefixEnvironment = `${stageEnvironment}.`;
const loadPrefixEnvironment = `${loadEnvironment}.`;
const developmentEnvironment = "development";
const localEnvironment = "localhost";
const hostnamesAllowed = [
	localEnvironment,
	latestEnvironment,
	stageEnvironment,
	loadEnvironment,
	productionEnvironment,
];
const developmentSubdomains = [localEnvironment, "versions"];
const helpCdnPathname = "/media/layout/help-ui";
const defaultLocalPort = "3000";

export const isDemoPage = () => {
	return window.location.pathname.includes(helpCdnPathname);
};

export const getEnvironment = () => {
	const defaultEnvironment = localStorage?.getItem("helpAppDefaultEnvironment");
	if (defaultEnvironment) {
		return defaultEnvironment;
	}
	const { hostname, pathname, port } = window.location;
	let mainSubdomain = hostname.split(".")[0];

	if (isDemoPage()) {
		mainSubdomain = pathname.split("/")[4];
	}

	if (
		developmentSubdomains.includes(mainSubdomain) ||
		(!!port && port === defaultLocalPort)
	)
		return developmentEnvironment;
	else if (hostnamesAllowed.includes(mainSubdomain)) return mainSubdomain;
	else return productionEnvironment;
};
export const isDevelopmentEnvironment = (environment) => {
	return environment === developmentEnvironment;
};

export const loadCdnCssFile = (cdnBaseURL, target) => {
	if (
		isDevelopmentEnvironment(getEnvironment()) &&
		target.includes("/themes/")
	) {
		cdnBaseURL = "/assets";
	}
	const cssUrl = `${cdnBaseURL}${target}`;

	if (!document.querySelector('link[href="' + cssUrl + '"]')) {
		const link = document.createElement("link");

		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = cssUrl;
		document.head.appendChild(link);
	}
};

export const loadAssetsCdnUrl = (url, env, isHelpAssetsPath) => {
	let serviceEnv = "";
	switch (env) {
		case developmentEnvironment:
			if (isHelpAssetsPath) {
				return "/assets";
			} else {
				env = latestEnvironment;
				serviceEnv = stagePrefixEnvironment;
			}
			break;
		case latestEnvironment:
		case stageEnvironment:
		case loadEnvironment:
			serviceEnv = stagePrefixEnvironment;
			break;
		default:
			serviceEnv = "";
	}
	return mapString(url, serviceEnv, env);
};

export const getIpServer = () => {
	let ipServer = getParam("ipServer");
	if (!ipServer) {
		ipServer = localEnvironment;
	}
	return ipServer;
};

export const loadEnvUrl = (url, env, { useLt01ApiPrefix = false } = {}) => {
	let serviceEnv = "";
	const ipServer = getIpServer();
	switch (env) {
		case developmentEnvironment:
			return `http://${ipServer}:3001/api`;
		case latestEnvironment:
			serviceEnv = latestPrefixEnvironment;
			break;
		case stageEnvironment:
			serviceEnv = stagePrefixEnvironment;
			break;
		case loadEnvironment:
			serviceEnv = useLt01ApiPrefix ? loadPrefixEnvironment : "load.";
			break;
		default:
			serviceEnv = "";
	}
	return mapString(url, serviceEnv, env);
};
